import { useEffect } from "react";

/**
 * Sets the document title after the component render is committed.
 *
 * @param title - The title to display in the browser tab.
 */
export const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};
